/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-12-01",
    versionChannel: "nightly",
    buildDate: "2023-12-01T00:15:00.502Z",
    commitHash: "656d41f022dbf4e54921b89882451eba625b98bd",
};
